export default __webpack_public_path__ + "34d1b1413e2e847f3dfb07eb36264514.png";